export enum ComparableDashboardWindowEnum {
  last_12_months = 'last_12_months',
  last_18_months = 'last_18_months',
}

export const COMPARABLE_DASHBOARD_WINDOW_LABEL: Record<ComparableDashboardWindowEnum, string> = {
  [ComparableDashboardWindowEnum.last_12_months]: 'Last 12 Months',
  [ComparableDashboardWindowEnum.last_18_months]: 'Last 18 Months',
};
